import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import {
    CreateVenueAgentInputDto,
    CreateVenueAgentResultDto,
} from "../../../models/court-recording/dto/venue-agent.dto";
import { GET_VENUE_AGENTS_QUERY_KEY } from "./useListVenueAgents";

export const useCreateVenueAgent = (organizationId: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: CreateVenueAgentInputDto) =>
            client.fetchApi<CreateVenueAgentResultDto, CreateVenueAgentInputDto>({
                endpoint: `court-recordings/admin/venue-agents?organizationId=${organizationId}`,
                method: 'POST',
                body: input,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: GET_VENUE_AGENTS_QUERY_KEY(organizationId),
            });
        },
    });
};
